"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAppStore = void 0;
var tslib_1 = require("tslib");
var redux_1 = require("redux");
var extension_1 = require("@redux-devtools/extension");
var redux_saga_1 = tslib_1.__importDefault(require("redux-saga"));
var history_1 = require("history");
var createRouterMiddleware_1 = require("./createRouterMiddleware");
var createTestingMiddleware_1 = require("./createTestingMiddleware");
var createAppStore = function (_a) {
    var history = _a.history, _b = _a.initialState, initialState = _b === void 0 ? {} : _b, _c = _a.enableLogger, enableLogger = _c === void 0 ? true : _c, flows = _a.flows, reduxLogger = _a.reduxLogger, rootReducer = _a.rootReducer;
    var sagaMiddleware = (0, redux_saga_1.default)();
    var testingMiddleware = (0, createTestingMiddleware_1.createTestingMiddleware)();
    var routerMiddleware = (0, createRouterMiddleware_1.createRouterMiddleware)(history || (0, history_1.createBrowserHistory)());
    var noOp = function (f) { return f; };
    var finalCreateStore = (0, extension_1.composeWithDevTools)((0, redux_1.applyMiddleware)(testingMiddleware), (0, redux_1.applyMiddleware)(sagaMiddleware), (0, redux_1.applyMiddleware)(routerMiddleware), // Should be after saga in order to get put actions
    enableLogger && reduxLogger ? (0, redux_1.applyMiddleware)(reduxLogger) : noOp)(redux_1.createStore);
    var store = finalCreateStore(rootReducer, initialState);
    if (flows) {
        sagaMiddleware.run(flows);
    }
    return store;
};
exports.createAppStore = createAppStore;
